/**
 * EL ALTA RAPIDA DE UN NEGOCIO: EL CASCARON (PANEL-WIZARD-MINIMO-T1, COORD de Ares #15542).
 *
 * DE DONDE SALE. Josse, 16-sep, antes de la prueba de instalacion: si Nexo llena toda
 * la ficha, el cuestionario del enlace no prueba nada, porque al cerrar solo llena lo
 * que esta vacio (api PR 257). El wizard completo se queda como esta; el boton
 * "+ Rapido" de Negocios pasa a ser la creacion minima.
 *
 * LO QUE PIDE: nombre comercial, tipo, plan y celular del propietario. La razon social
 * es opcional y vacia NO se rellena (la llena el cuestionario; el Desktop cae al nombre
 * comercial mientras tanto). Todo lo demas queda vacio para el cliente.
 *
 * LA SUSCRIPCION: igual que el wizard (plan, activa, mensual, 0 COP, desde hoy, 1 mes).
 * Sin ella el negocio no pasa la licencia en el primer arranque del Desktop.
 *
 * EL CONTRATO (NexoAPI CreateBusinessDto): solo DisplayName es [Required]. El celular va
 * en metadata.ownerPhone, que es donde el cierre del cuestionario lo busca
 * (spec-datos-del-negocio). El telefono del NEGOCIO no se manda: es otra pregunta.
 *
 * Sin DOM: lo prueba scripts/check-alta-rapida.mjs.
 */

export const MESES_DE_LA_SUSCRIPCION = 1;

const texto = (v) => (typeof v === 'string' ? v.trim() : '');

/** Digitos del celular sin el 57 de Colombia. */
function digitosDelCelular(v) {
  const d = texto(v).replace(/\D/g, '');
  return d.length === 12 && d.startsWith('57') ? d.slice(2) : d;
}

/** Lo que falta, en palabras, o null si se puede crear. */
export function problemaDelAltaRapida(datos = {}) {
  if (!texto(datos.displayName)) return 'Falta el nombre comercial';
  if (!texto(datos.businessType)) return 'Elige el tipo de negocio';
  if (!texto(datos.plan)) return 'Elige el plan';
  if (!texto(datos.ownerPhone)) return 'Falta el celular del propietario: es el WhatsApp con el que Argemiro lo reconoce';
  if (digitosDelCelular(datos.ownerPhone).length !== 10) return 'El celular del propietario debe tener 10 digitos (ej: 300 123 4567)';
  return null;
}

/** El cuerpo de POST /api/businesses. Solo lo que Nexo pone; lo demas lo llena el cliente. */
export function cuerpoDelAltaRapida(datos = {}) {
  return {
    displayName: texto(datos.displayName),
    legalName: texto(datos.legalName) || null,
    businessType: texto(datos.businessType),
    plan: texto(datos.plan),
    metadata: { ownerPhone: texto(datos.ownerPhone) }
  };
}

/** Fin de la suscripcion: el mismo dia N meses despues (la regla del wizard). */
export function finDeLaSuscripcion(inicioIso, meses = MESES_DE_LA_SUSCRIPCION) {
  const d = new Date(String(inicioIso) + 'T12:00:00');
  if (isNaN(d.getTime())) return null;
  d.setMonth(d.getMonth() + Number(meses));
  return d.toISOString().slice(0, 10);
}

/** El cuerpo de POST /api/businesses/{id}/subscriptions, igual al del wizard. */
export function cuerpoDeLaSuscripcion(plan, inicioIso) {
  return {
    plan: texto(plan),
    status: 'active',
    billingCycle: 'monthly',
    amount: 0,
    currency: 'COP',
    startDate: inicioIso,
    endDate: finDeLaSuscripcion(inicioIso) || undefined,
    notes: `Creada por alta rapida (${MESES_DE_LA_SUSCRIPCION} mes)`
  };
}

/** Hoy en Bogota como YYYY-MM-DD (despues de las 7 p. m. la fecha UTC ya es manana). */
export function hoyEnBogota(ahora = new Date()) {
  return ahora.toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}
